// apps/web/src/components/landing-v2/proofs/IntentionProof.tsx
/** Theme 01 / Set an intention — text input with typewriter cursor + chip
 *  suggestions.  Reference: handoff .mm-intention. */
export function IntentionProof() {
  return (
    <div className="absolute inset-0 flex flex-col p-[18px]">
      <span className="inline-flex w-fit items-center gap-1.5 rounded-pill border border-astral-violet/30 bg-astral-violet/[0.16] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-astral-violet-light">
        Intention
      </span>
      <div
        className="mt-3 min-h-[64px] rounded-lg border px-3 py-3 font-display italic text-text-primary"
        style={{
          borderColor: 'color-mix(in oklab, var(--color-astral-violet) 35%, transparent)',
          background: 'color-mix(in oklab, var(--color-astral-violet) 6%, transparent)',
          fontSize: '0.92rem',
        }}
      >
        What should I trust right now?
        <span
          className="landing-v2-cursor ml-0.5 inline-block align-[-2px]"
          style={{
            width: '0.1em',
            height: '0.9em',
            background: 'var(--color-astral-violet-light)',
          }}
        />
      </div>
      <div className="mt-auto flex flex-wrap gap-1.5 pt-3">
        <span className="rounded-pill border border-hairline bg-hairline-faint px-2.5 py-1 text-[11px] text-text-secondary">
          What&apos;s the next step?
        </span>
        <span className="rounded-pill border border-hairline bg-hairline-faint px-2.5 py-1 text-[11px] text-text-secondary">
          What am I avoiding?
        </span>
      </div>
    </div>
  )
}
